import { FC } from 'react';
import { getPriceSummaryData } from './lib/getPriceSummaryData';
import { PriceSummaryProps } from './types';
import { PriceSummaryContent } from './content';

export const PriceSummary: FC<PriceSummaryProps> = ({ activePlan, config, effectiveCart }) => {
  const summary = getPriceSummaryData({ activePlan, effectiveCart });

  return <PriceSummaryContent config={config} summary={summary} />;
};
